import { ArrowDropDown, ArrowRight } from '@material-ui/icons'
import { useObserver } from 'mobx-react-lite'
import React, { FC, memo } from 'react'
import useItemContext from '../../hooks/use-item-context'
import * as css from './CollapseHierarchy.css'

const CollapseHierarchy: FC<{ id }> = memo(({ id }) =>
  useObserver(function useHook() {
    const {
      store: {
        store: {
          hierarchyCollapseStore: { isCollapsed, setCollapsedState },
          scrollPositionStore: { scrollLeft }
        },
        debouncedRecompute
      }
    } = useItemContext()
    return (
      <div className={css['hierarchy-collapse-btn']} style={{ left: scrollLeft }}>
        {id && isCollapsed(id) ? (
          <ArrowDropDown
            className='m-auto'
            onClick={() => {
              setCollapsedState(id, false)
              debouncedRecompute()
            }}
          />
        ) : (
          <ArrowRight
            className='m-auto'
            onClick={() => {
              setCollapsedState(id, true)
              debouncedRecompute()
            }}
          />
        )}
      </div>
    )
  })
)

export default CollapseHierarchy
